import { createRouter, createWebHashHistory } from 'vue-router'
import ComponentGalleryApp from './ComponentGalleryApp.vue'
import SearchGalleryApp from './SearchGalleryApp.vue'
import PrescriptionGallery from './PrescriptionGallery.vue'
import CmmElectronicPriorAuthorizationQuestionnaire from '../ChoiceScreens/Prescriptions/CoverMyMeds/ePA/CmmElectronicPriorAuthorizationQuestionnaire.vue';
import CmmEPAQuestionnaireAnswersGallery from '../gallery/Prescriptions/CmmEPA/CmmEPAQuestionnaireAnswersGallery.vue'
import CmmEPATestCaseGallery from '../gallery/Prescriptions/CmmEPA/CmmEPATestCaseGallery.vue'
import PatientComponentGallery from '../gallery/PatientComponentGallery.vue'
import UtilityFunctions from '../gallery/UtilityFunctions.vue'
import SurescriptsComponentGallery from './SurescriptsComponentGallery.vue';
import ChoiceCompsGallery from './Choice/ChoiceCompsGallery.vue';

const routes = [
    { path: '/', component: ComponentGalleryApp },
    { path: '/search', component: SearchGalleryApp },
    { path: '/utilityFunctions', component: UtilityFunctions },
    { path: '/prescriptions', component: PrescriptionGallery },
    { path: '/prescriptions/Cmm/ePA/Questionnaire', component: CmmElectronicPriorAuthorizationQuestionnaire, props:{ cmmEpaCallbackId: -20 } },
    { path: '/prescriptions/Cmm/ePA/QuestionnaireAnswers', component: CmmEPAQuestionnaireAnswersGallery },
    { path: '/prescriptions/Cmm/ePA/TestCases', component: CmmEPATestCaseGallery },
    { path: '/choice/patient', component: PatientComponentGallery },
    { path: '/choice/surescripts', component: SurescriptsComponentGallery },
    { path: '/choice/ChoiceComps', component: ChoiceCompsGallery }
 ];


export function getRouter()
{
    return createRouter({
        // Provide the history implementation to use
        //  IMPORTANT -- Do not expose the route using a variable instead of a function call when using hash history. 
        //                  It will break OFficeMd when it looks at QueryString data.  Adding #/ which breaks pages
        history: createWebHashHistory(),
        routes:  routes
        });
}

